import styled from "styled-components";

export const Container = styled.div`
   background-color: #c0ee2d;
   border-radius: 30px;
   padding: ${({ solicitarPremio }) => (solicitarPremio ? "0px 0px" : "15px 0px")};
   height: ${({ solicitarPremio }) => (solicitarPremio ? "377px" : "auto")};
   img{
      margin: auto;
   }
   .productText{
      padding: 0px 20px;
      margin-bottom:  ${({ solicitarPremio }) => (solicitarPremio ? "30px" : "10px")};
   }
   .addProduct{
      background-color: #0d5b5b;
      width: 100%;
      height: 50px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      img{
         width: 20px;
      }
   }
`;

